/** Shared socials — footer + Organization.sameAs. Add new channels here only. */
export const SOCIALS = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/soldikeeper/',
    icon: 'instagram',
  },
];

/** Play Store stays in sameAs (app listing, not a social channel). */
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.soldikeeper.app';

export const ORGANIZATION_SAME_AS = [
  PLAY_STORE_URL,
  ...SOCIALS.map((s) => s.href),
];
